export const useElementSelector = <T = HTMLElement | null>(selector: string) => {
	const el = ref<HTMLElement | null>(null)

	if (selector) {
		el.value = document?.querySelector(selector)
	}
	return el as Ref<T>
}
